import { Box, IconButton, Switch } from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import { RiDeleteBinLine, RiFileEditLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import {
  activeChapterRequest,
  deleteChapterRequest,
  restrictChapterRequest,
} from "../../../modules/admin-modules/chapters/Actions";
import { openCreateChapterModel } from "../../../modules/admin-modules/models/Actions";

const C = {
  primary: "#6A1E1E",
  secondary: "#4A0F1F",
  border: "#D8CEC3",
};

const iconBtnProps = {
  variant: "ghost",
  border: "0",
  size: "sm",
  color: C.primary,
  _hover: { bg: "rgba(106, 30, 30, 0.08)", color: C.secondary },
};

const ChaptersTable = ({
  setAdd,
  setSelectedData,
  searchTerm = "",
  inactiveOnly = false,
}) => {
  const chapters = useSelector((state) => state.chapters.chapters);
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.chapters.isLoading);
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);

  const list = useMemo(() => {
    let raw = Array.isArray(chapters) ? chapters : [];
    if (inactiveOnly) {
      raw = raw.filter((c) => Number(c?.active) === 0);
    }
    else {
      raw = raw.filter((c) => Number(c?.active) === 1);
    }
    const q = (searchTerm || "").trim().toLowerCase();
    if (!q) return raw;
    return raw.filter((c) => c?.name?.toLowerCase().includes(q) || c?.name_ar?.toLowerCase().includes(q));
  }, [chapters, searchTerm, inactiveOnly]);

  useEffect(() => {
    setPageNumber(0);
  }, [searchTerm]);

  const viewData = (row) => {
    const plain = list.find((c) => c.id === row?.id) ?? row;
    setSelectedData(plain);
  };

  const Data = list.map((data) => ({
    ...data,
    id: data?.id,
    name: data?.name_ar || data?.name,
    payment: data?.payment_subject?.name,
    edit: (
      <IconButton
        {...iconBtnProps}
        aria-label="Edit chapter"
        fontSize="20px"
        icon={<RiFileEditLine />}
        onClick={(e) => {
          e.stopPropagation();
          setSelectedData(data);
          setAdd(false);
          dispatch(openCreateChapterModel());
        }}
      />
    ),
    delete: (
      <IconButton
        {...iconBtnProps}
        aria-label="Delete chapter"
        fontSize="20px"
        icon={<RiDeleteBinLine color="#9b2c2c" />}
        onClick={(e) => {
          e.stopPropagation();
          dispatch(deleteChapterRequest(data?.id));
        }}
      />
    ),
  }));

  let columns = [
    { Header: "Lesson", accessor: "name" },
    { Header: "Payment", accessor: "payment" },
    { Header: "Edit", accessor: "edit" },
    { Header: "Delete", accessor: "delete" },
  ];

  if(inactiveOnly) {
    columns = [
      { Header: "Container", accessor: "name" },
      { Header: "Edit", accessor: "edit" },
      { Header: "Delete", accessor: "delete" },
    ];
  }

  const totalPage = Math.max(1, Math.ceil(list.length / size));

  return (
    <Box px={{ base: 4, md: 8 }} pb={10} w="100%">
      <Box
        bg="rgba(255,255,255,0.9)"
        border="1px solid"
        borderColor={C.border}
        borderRadius="16px"
        overflow="hidden"
        boxShadow="sm"
      >
        <CTable
          selectedData={viewData}
          Columns={columns}
          Data={Data}
          path="openModel"
          Title=""
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar
          noFilter
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar
          isLoading={isLoading}
          perPage={size}
          totalPage={totalPage}
          wrapperProps={{ maxH: "unset", overflow: "auto" }}
          tableProps={{ bg: "transparent", borderRadius: "0", mb: 0 }}
          theadProps={{ bg: "#D8CEC3", color: "#4A0F1F" }}
        />
      </Box>
    </Box>
  );
};

export default ChaptersTable;
